let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f2eDS")).then(() => parcelRequire('kNFXg'));